import React from 'react';
import { motion } from 'framer-motion';
export function TestimonialsBanner() {
  return <section className="w-full bg-brand-bg pt-6 md:pt-8 pb-12 md:pb-16 px-6 overflow-hidden" data-id="element-406">
      <motion.div className="max-w-5xl mx-auto text-center relative" initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} data-id="element-407">
        {/* Green glow behind the text */}
        <div className="absolute left-1/2 -translate-x-1/2 top-[20%] w-[800px] h-[600px] bg-[#22c55e]/[0.14] rounded-full blur-[120px] pointer-events-none" data-id="element-408" />

        <h2 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-gray-900 leading-tight relative z-10" data-id="element-409">
          Más testimonios de
          <br data-id="element-410" />
          los resultados de
          <br data-id="element-411" />
          <span className="text-[#1fa855]" data-id="element-412">Emprende Digital</span>
        </h2>
        <p className="text-lg md:text-2xl text-gray-600 mt-4 relative z-10" data-id="element-413">
          Lo que pasa cuando aplican este curso 👇
        </p>
      </motion.div>
    </section>;
}